import React from 'react';
import './App.css';
import Calendar from './components/Calendar'

function App() {
    return (
        <>
            <Calendar />
        </>
    );
}

export default App;